// extracted by mini-css-extract-plugin
export default {"playerTable":"PlayerTable_playerTable__jGdLx","header":"PlayerTable_header__zmqSV","search":"PlayerTable_search__GyOQi","searchInput":"PlayerTable_searchInput__8kj7Y"};